import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { OperatorConfigurations } from './OperatorConfigurations';
import { OperatorContacts } from './OperatorContacts';
import { OperatorWarehouses } from './OperatorWarehouses';
import { getOperatorContacts, getOperatorWarehouses } from '../../../store/actions/operators';

import styles from './OperatorSellerPage.module.scss';

export function OperatorSellerPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOperatorContacts());
    dispatch(getOperatorWarehouses());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.wrapper}>
      <OperatorConfigurations />
      <OperatorContacts />
      <OperatorWarehouses />
    </div>
  );
}
